<input
  autocomplete="nope"
  type="text"
  #countryInput
  terraForceAutoCompleteSelection
  [formControl]="formControl"
  [matAutocomplete]="autoComplete"
  (cdkAutofill)="setAutofillState($event.isAutofilled)"
  class="country-input"
  (focus)="$event.target.select()"
  [placeholder]="placeholder"
  [attr.aria-labelledby]="parentFormField?.getLabelId()"
  [id]="inputId"/>

<mat-autocomplete #autoComplete="matAutocomplete"
                  (optionSelected)="selectFromAutocomplete($event.option.value)" autoActiveFirstOption>
  <mat-option *ngFor="let country of filteredCountries$ | async; trackBy: conutryTrackByFn" [value]="country.name">
    <span class="notranslate">{{ country.name }}</span>
  </mat-option>
</mat-autocomplete>
